// extracted by mini-css-extract-plugin
module.exports = {"ArticleGreetings":"ArticleGreetings_ArticleGreetings__NImA7","text":"ArticleGreetings_text__8waKB","name":"ArticleGreetings_name__s40E_"};